import { documentationActions } from '../../actions/constant';

const {
  REQUEST_DAILY_SESSION_NOTES_SIGN,
  SUCCESS_DAILY_SESSION_NOTES_SIGN,
  FAILURE_DAILY_SESSION_NOTES_SIGN,
  LOADER_DAILY_SESSION_NOTES_SIGN,
  RESET_DAILY_SESSION_NOTES_SIGN,
} = documentationActions;

const intitialstate: object = {
  response: null,
  loading: false,
  isCheckSign: false,
};

export const checkSignatureDailyNotesReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_DAILY_SESSION_NOTES_SIGN: {
      return {
        ...state,
        isCheckSign: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_DAILY_SESSION_NOTES_SIGN:
      return {
        ...state,
        isCheckSign: false,
        response: action.payload,
        loading: false,
      };

    case LOADER_DAILY_SESSION_NOTES_SIGN:
      return {
        ...state,
        loading: true,
      };

    case RESET_DAILY_SESSION_NOTES_SIGN:
      return intitialstate;
    default:
      return state;
  }
};
